import { makeEroadStyles } from "../../../styles";

const useStyles = makeEroadStyles(
  (theme) => ({
    root: {
      position: "relative",
      height: "100%",
      overflowY: "auto",
      backgroundColor: theme.colors.surfaceLevel2, // required in depot only.
      display: "flex",
      flexDirection: "column",
    },
  }),
  { name: "Page" }
);

export { useStyles };
